import PropTypes from 'prop-types';
import React, { useEffect, useState } from "react";
import Footer from '../../components/Common/Footer';

import { Alert, Card, CardBody, Col, Container, Form, FormFeedback, Input, Row } from "reactstrap";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";

// Formik validation
import { useFormik } from "formik";
import * as Yup from "yup";

//Social Media Imports
// import { GoogleLogin } from "react-google-login"
import { GoogleLogin } from '@react-oauth/google';

// import TwitterLogin from "react-twitter-auth"

// actions
import { loginUser, loginUserGoogle } from "../../store/actions";

// import images
import logolight from "../../assets/images/holcimlogoAdipi.png";

//Import config

const Login = (props) => {

  const dispatch = useDispatch();
  const [isGoogle, setGoogleAuth] = useState(false)
  const [showPassword, setShowPassword] = useState(false);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values need to be changed
    enableReinitialize: true,
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Ingrese correo electrónico"),
      password: Yup.string().required("Ingrese contraseña"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.history));
    }
  });

  const error = useSelector(state => state.Login.error);

  const googleResponse = response => {
    const body = { googleTokenId: response.credential };
    dispatch(loginUserGoogle(body, props.history));
  }

  const googleResponseFailure = response => {
    console.log('Response:', response)
  }

  useEffect(() => {
    document.body.className = "authentication-bg";
    return function cleanup() {
      document.body.className = "";
    };
  });

  return (
    <React.Fragment>
      <div className="my-5 pt-sm-5" >
        <Container >
          <Row className="align-items-center justify-content-center">
            <Col xs={10} sm={10} md={8} lg={6} xl={6}>
              <Card className=''>
                <CardBody className="p-5 rounded-5">
                  <div className="text-center">
                    <Link to="/" className="d-block auth-logo">
                      <img src={logolight} alt="" height="52" className="logo logo-dark" />
                    </Link>
                  </div>
                  <div className="d-flex justify-content-end">
                    <button onClick={() => {
                      setGoogleAuth(!isGoogle)
                    }}
                      className="btn btn-primary w-1"
                    >
                      {
                        isGoogle ? <i size="40" className="mdi mdi-google" /> : <i size="40" className="mdi mdi-account" />
                      }
                    </button>
                  </div>
                  <div className="text-center mt-3">
                    <strong><h3 className="text-primary">DiPi - Digital Platform of Innovation</h3></strong>
                    <h5 className="text-center mt-4">Diseñada para la gestión de los procesos y la presentación de resultados de la Gerencia de Innovación</h5>
                  </div>
                  <div className="p-2 mt-4">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {
                        isGoogle ? <>
                          <div className="mb-3">
                            <Input
                              name="email"
                              className="form-control"
                              placeholder="Ingrese correo electrónico"
                              type="email"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email || ""}
                              invalid={
                                validation.touched.email && validation.errors.email && isGoogle ? true : false
                              }
                            />
                            {validation.touched.email && validation.errors.email ? (
                              <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <div className="position-relative">
                              <Input
                                name="password"
                                value={validation.values.password || ""}
                                type={showPassword ? "text" : "password"}
                                placeholder="Ingrese contraseña"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                  validation.touched.password && validation.errors.password && isGoogle ? true : false
                                }
                              />
                              <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="btn position-absolute end-0 top-50 translate-middle-y me-1"
                                style={{ border: 'none', background: 'none', zIndex: 10, padding: '0 8px' }}
                              >
                                <i className={showPassword ? "mdi mdi-eye-off-outline" : "mdi mdi-eye-outline"} style={{ fontSize: '18px', color: '#74788d' }} />
                              </button>
                            </div>
                            {validation.touched.password && validation.errors.password ? (
                              <div className="invalid-feedback" style={{ display: 'block' }}>{validation.errors.password}</div>
                            ) : null}
                            {error ? <Alert fade className='mt-3 text-center' color="danger">Credenciales incorrectas, intente de nuevo.</Alert> : null}
                          </div> </> : null
                      }

                      {
                        isGoogle ?
                          <div className="mt-4">
                            <button
                              className="btn btn-primary w-100 rounded-4"
                              type="submit"
                            >
                              <i className="mdi mdi-user me-2" />
                              Iniciar Sesión
                            </button>
                          </div> :
                          <div className='d-flex justify-content-center'>
                            <GoogleLogin
                              onSuccess={googleResponse}
                              onFailure={googleResponseFailure}
                            />
                          </div>

                      }

                      <div className="mt-3">
                        <Link to="/register" className="d-block auth-logo">
                          <button
                            className="btn btn-primary w-100 rounded-4"
                            type="submit"
                          >
                            <i size="30" className="mdi mdi-account me-2" />
                            Registrarse por primera vez
                          </button>
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login);

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func
}
